/* Duo Cases — behaviour for the custom "duo-" sections. No dependencies. */
(function () {
  'use strict';

  /* Fold demo: tabs switch the drawn phone between its states. */
  function initFold(root) {
    if (root.dataset.duoReady) return;
    root.dataset.duoReady = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    var shots = Array.prototype.slice.call(root.querySelectorAll('[data-duo-shot]'));
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!tabs.length) return;

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p) {
        p.hidden = p.id !== tab.getAttribute('aria-controls');
      });
      root.dataset.state = tab.dataset.state;

      /* Real photos / clips: show the one that belongs to this state, if any. */
      var hasShot = false;
      shots.forEach(function (shot) {
        var on = shot.getAttribute('data-duo-shot') === tab.dataset.block;
        shot.classList.toggle('is-active', on);
        var video = shot.querySelector('video');
        if (on) {
          hasShot = true;
          if (video && !reduceMotion) {
            try {
              video.hidden = false;
              video.currentTime = 0;
              var playing = video.play();
              if (playing && playing.catch) playing.catch(function () {});
            } catch (err) {}
          }
        } else if (video) {
          video.pause();
        }
      });
      root.dataset.shot = hasShot ? 'true' : 'false';

      if (focus) tab.focus();
    }

    /* Case colour picker: recolours the drawn phone. */
    var device = root.querySelector('.duo-fold__stage .duo-device');
    var colours = Array.prototype.slice.call(root.querySelectorAll('.duo-fold__colour'));
    colours.forEach(function (btn, i) {
      if (i === 0) btn.setAttribute('aria-pressed', 'true');
      btn.addEventListener('click', function () {
        colours.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (device) {
          device.style.setProperty('--duo-case', btn.dataset.case);
          device.style.setProperty('--duo-case-edge', btn.dataset.edge);
        }
      });
    });

    /* Fetch the clips shortly before the section scrolls into view. */
    var clips = Array.prototype.slice.call(root.querySelectorAll('.duo-fold__shot video'));
    if (clips.length && !reduceMotion) {
      var warm = function () {
        clips.forEach(function (v) {
          v.preload = 'auto';
          try {
            v.load();
          } catch (err) {}
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            if (entries.some(function (e) { return e.isIntersecting; })) {
              io.disconnect();
              warm();
            }
          },
          { rootMargin: '600px 0px' }
        );
        io.observe(root);
      } else {
        warm();
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) {
          e.preventDefault();
          select(next, true);
        }
      });
    });
  }

  /* Delivery estimate: today + handling + transit, counted in business days. */
  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) left -= 1;
    }
    return d;
  }

  function initDelivery(root) {
    if (root.dataset.duoReady) return;
    root.dataset.duoReady = 'true';

    var locale = document.documentElement.lang || undefined;
    var fmt = function (d) {
      try {
        return d.toLocaleDateString(locale, { month: 'long', day: 'numeric' });
      } catch (err) {
        return d.toDateString();
      }
    };

    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var todayEl = root.querySelector('[data-duo-today]');
    if (todayEl) todayEl.textContent = fmt(today);

    var box = root.querySelector('[data-duo-estimate]');
    if (!box) return;

    var handling = parseInt(box.dataset.handling, 10) || 0;
    var min = parseInt(box.dataset.min, 10);
    var max = parseInt(box.dataset.max, 10);
    if (isNaN(min) || isNaN(max) || max < min) return;

    var first = addBusinessDays(today, handling + min);
    var last = addBusinessDays(today, handling + max);
    var range = box.querySelector('[data-duo-range]');
    if (range) range.textContent = fmt(first) + ' – ' + fmt(last);

    var launchNote = box.querySelector('[data-duo-launch]');
    if (launchNote && box.dataset.launch) {
      var parts = box.dataset.launch.split('-');
      var launch = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      var daysEarly = Math.round((launch - last) / 86400000);
      launchNote.hidden = !(daysEarly >= 1);
    }

    box.hidden = false;
  }

  function init(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-duo-fold]'), initFold);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-duo-delivery]'), initDelivery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor: re-run when a section is added or re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
